const React = require("react")
const { Home } = require("./icons/home")
const { Product } = require("./icons/product")
const { Support } = require("./icons/support")
const { Protocol } = require("./icons/protocol")
const { Traffic } = require("./icons/cotaDados")
const { InterfaceOnline } = require("./icons/interfaceOnline")
const { Sair } = require("./icons/sair")
const { Invoice } = require("./icons/invoice")
const { Arrow } = require("./icons/arrow")
const { ContractsOrders } = require("./icons/contractsOrders")
const { ConsumptionProfile } = require("./icons/consumption_profile")
const { Users } = require("./icons/users")
const { Monitoring } = require("./icons/monitoring")

module.exports = {
  Home: (props) => <Home {...props} />,
  Product: (props) => <Product {...props} />,
  Support: (props) => <Support {...props} />,
  Protocol: (props) => <Protocol {...props} />,
  Traffic: (props) => <Traffic {...props} />,
  InterfaceOnline: (props) => <InterfaceOnline {...props} />,
  Sair: (props) => <Sair {...props} />,
  Invoice: (props) => <Invoice {...props} />,
  Arrow: (props) => <Arrow {...props} />,
  ContractsOrders: (props) => <ContractsOrders {...props} />,
  ConsumptionProfile: (props) => <ConsumptionProfile {...props} />,
  Users: (props) => <Users {...props} />,
  Monitoring: (props) => <Monitoring {...props} />
}



// WEBPACK FOOTER //
// ./src/shared/skin/icons/menu/index.js